import { useTranslation } from 'react-i18next';
import { TransactionStatusEnum } from '@delmonicos/shared-sdk/libs/emsp/src/libs/shared/src/transaction-service/enum/transaction-status.enum';

type GetChargingSessionStatusTextHookReturn = (
  status: TransactionStatusEnum,
) => string;

export function useGetChargingSessionStatusText(): GetChargingSessionStatusTextHookReturn {
  const { t } = useTranslation();

  return (statusNumber: TransactionStatusEnum) => {
    const statusText = t(
      `model.enum.charging-session-status-enum.${statusNumber}`,
    );

    return `${statusNumber} - ${statusText}`;
  };
}
